<form class="bootstrap-validation-background--hidden" [formGroup]="form" (ngSubmit)="trigger(true)">
  <portal-modal-header
    [entry]="entry"
    [title]="(canAddOrDelete ? 'phoneBook.contact.group.edit' : 'phoneBook.group.contacts.label') | translate"
    (onClose)="close()"
  ></portal-modal-header>

  <portal-modal-body>
    <portal-error-alert [error]="error"></portal-error-alert>

    <!-- Name -->
    <div class="form-group">
      <label class="form-label" for="name">{{ 'general.name' | translate }}</label>

      @if (isNew === true || isFavorite === false) {
        <input
          class="form-control"
          id="name"
          [portalAutofocus]="canAddOrDelete"
          [readonly]="!canAddOrDelete"
          autocomplete="off"
          formControlName="name"
          portalInputValidityState
          type="text"
        />
        <portal-form-validation-errors controlName="name"></portal-form-validation-errors>
      } @else {
        <p>{{ 'phoneBook.contact.group.favourites' | translate }}</p>
      }
    </div>

    <label class="form-label">{{ 'phoneBook.group.contacts' | translate }}</label>

    <portal-elements-selector
      [elements]="contacts"
      [elementTemplate]="contactTemplate"
      [noAvailableSection]="canAddOrDelete === false"
      [readonly]="canAddOrDelete === false"
      [searchProperties]="['lastName', 'firstName', 'company', 'businessPhone']"
      [sortProperties]="['lastName', 'firstName', 'company']"
      elementsLabel="phoneBook.group.choosable.contacts.label"
      formControlName="contacts"
      selectedElementsLabel="phoneBook.group.contacts.label"
    ></portal-elements-selector>
  </portal-modal-body>

  <portal-modal-footer
    [closeOnly]="!canAddOrDelete"
    [entry]="entry"
    [form]="form"
    [saving]="saving"
    (onCancel)="trigger(false)"
  ></portal-modal-footer>
</form>

<ng-template #contactTemplate let-contact>
  <div>
    <span>{{ contact | contactName }}</span>
    @if (contact.businessPhone || contact.mobilePhone || contact.businessFax || contact.homePhone) {
      <div>
        <small>{{
          contact.businessPhone ?? contact.mobilePhone ?? contact.businessFax ?? contact.homePhone
        }}</small>
      </div>
    }
  </div>
</ng-template>
